import useLocalStorageObj from "./useLocalStorageObj";

export default function useOperatorStorage() {
  const {getObj, setObj} = useLocalStorageObj('operator');

  return {
    operator: getObj,
    setOperator: setObj
  }
}
